export default __webpack_public_path__ + "static/media/qb7s961yxt751.1d6b4d13.jpg";